import React from 'react';
import { Route } from 'react-router-dom';
import SearchPageRoute from './SearchPageRoute';

const basePath = '/v2/search';

export default (
  <Route path={basePath}>
    <Route exact path={basePath}>
      <SearchPageRoute />
    </Route>
  </Route>
);
